import EventEmitter from '../../../util/eventEmitter.js';
import Content from '../../content.js';
import Modal from '../../components/modal';

var Show = Content.extend({
  dom: {
    REQUIRED_FEATURE: '#property_required_feature',
    PROPERTY_TYPE: '#property_property_type',
    ALLOW_ADVANCED: '.allow_octet_replacement',
    DELETE_BUTTON: '.action-bar .alert.button',
    SIDE_PANEL: '.HashPropertiesPanel',
    EDIT_BUTTON: '.io-form-action-edit',
    CANCEL_BUTTON: '.io-form-action-cancel',
    PREVIEW_BUTTON: '.io-form-action-preview',
    HASH_COMPONENT: '#hash-tree-container',
    IMPACT_TABLE: '#impactTable',
    IMPACT_FORM: '#impact-form',
    IMPACT_CANCEL: '#impact-form .io-form-action-cancel',
    IMPORT_HASH_DEFINITION: '.io-form-action-import-hash',
    CANCEL_IMPORT_HASH_DEFINITION: '.cancel-import-hdefinition',
    SERVICE_CHECK: '#property_service_checkable',
    SERVICE_CHECK_CONFIG: '#property_service_config',
    MULTIPLE_VALUE: '#property_multiple_values',
  },

  events: function () {
    var events = {};

    events['click ' + this.dom.IMPACT_CANCEL] = '_impactCancel';
    events['change ' + this.dom.REQUIRED_FEATURE] = '_showFeatureWarning';
    events['change ' + this.dom.PROPERTY_TYPE] = '_toogleAllowAdvanced';
    events['click ' + this.dom.DELETE_BUTTON] = '_warnImpact';
    events['click ' + this.dom.EDIT_BUTTON] = '_dispatchClickEditActions';
    events['click ' + this.dom.CANCEL_BUTTON] = '_disableSidePanel';
    events['click ' + this.dom.PREVIEW_BUTTON] = '_openPreview';
    events['click ' + this.dom.IMPORT_HASH_DEFINITION] = '_importHash';
    events['click ' + this.dom.SERVICE_CHECK] = '_toggleServiceCheck';
    events['click ' + this.dom.MULTIPLE_VALUE] = '_toggleServiceCheckField';
    return events;
  },

  render: function () {
    var sidePanel = $(this.dom.SIDE_PANEL),
      $impactTable = window.$(this.dom.IMPACT_TABLE),
      panelOffset;

    prettyPrint(); // used by hash diff table in the impact page

    if (sidePanel.length > 0) {
      panelOffset = sidePanel.offset().top;
      $(window).scroll(function () {
        if ($(window).scrollTop() >= panelOffset) {
          sidePanel.addClass('fixed');
        } else {
          sidePanel.removeClass('fixed');
        }
      });
    }
    if ($impactTable.length > 0) {
      this.impactTable = new DataTables({
        el: $impactTable,
        columns: window.affected_resources_header,
        data: window.afected_resources_rows,
        aoColumnDefs: [
          {
            sClass: 'impact-customer-code',
            aTargets: 0,
          },
        ],
      });
      this.impactTable.start();
    }
  },

  _dispatchClickEditActions: function () {
    this._enableSidePanel();
    this._enableHashActionButtons();

    // disable service_checkable checkbox if the property is set to be multiple value already
    this._toggleServiceCheckField();
  },

  _openPreview: function () {
    EventEmitter.emit('openHashBuilderPreview');
  },

  _enableSidePanel: function () {
    EventEmitter.emit('enableHashBuilderSidePanel');
  },

  _disableSidePanel: function () {
    EventEmitter.emit('disableHashBuilderSidePanel');
  },

  _toggleServiceCheckField: function () {
    var serviceCheckField = $(this.dom.SERVICE_CHECK);

    if ($(this.dom.MULTIPLE_VALUE).is(':checked')) {
      serviceCheckField.attr('disabled', 'disabled');
      serviceCheckField.prop('checked', false);
      $(this.dom.SERVICE_CHECK_CONFIG).val('');
    } else {
      serviceCheckField.prop('disabled', false);
    }

    this._toggleServiceCheck();
  },

  _toggleServiceCheck: function () {
    var serviceName = $('.service_config');

    if ($(this.dom.SERVICE_CHECK).is(':checked')) {
      serviceName.removeClass('hidden');
      serviceName.find('input').attr('required', true);
    } else {
      serviceName.addClass('hidden');
      serviceName.find('input').prop('required', false);
    }
  },

  _importHash: function () {
    var content;

    if (typeof this.importModal === 'undefined') {
      this.importModal = new Modal({ id: 'import-hdefinition-modal' });
      this._attachImportModalEvents();
    }

    content = JST['templates/properties/import_hash_defintion']();
    this.importModal.setContent(content);
    this.importModal.show();
  },

  _attachImportModalEvents: function () {
    var prettyView = $.proxy(this._prettify, this),
      importHDefintion = $.proxy(this._importHDefinition, this);

    this.importModal.$el.on('click', '.hdefinition-pretty-view', prettyView);
    this.importModal.$el.on('click', '.import-hdefinition', importHDefintion);
  },

  _prettify: function () {
    var currentValue = $('.hdefinition-text-area').val(),
      tabSize = 2;

    if (this._validJsonDefintion(currentValue)) {
      $('.hdefinition-text-area').val(
        JSON.stringify(JSON.parse(currentValue), undefined, tabSize),
      );
    }
  },

  _importHDefinition: function () {
    var source = $('#hash_definition').val(),
      content;

    if (!this._validJsonDefintion(source)) {
      this._showImportDefinitionErrors(
        JST['templates/properties/hash_def_inline_errors']({
          errors: {
            global: ['An invalid JSON cannot be imported.'],
          },
        }),
      );
      return;
    }

    EventEmitter.emit('setDefinitionErrors', {});
    this._cleanImportDefinitionErrors();
    $.ajax({
      url: '/' + currentCustomer + '/properties/validate_hash_definition',
      context: this,
      method: 'POST',
      dataType: 'json',
      data: { hash_definition: source },
      success: function (data) {
        if (
          data.valid_definition === false ||
          (data.errors &&
            Object.keys(data.errors).indexOf('hash_definition') > -1)
        ) {
          content = JST['templates/properties/hash_def_inline_errors']({
            errors: data.errors,
          });
          this._showImportDefinitionErrors(content);
          return;
        }

        if (data.valid === false) {
          EventEmitter.emit('setDefinitionErrors', data.errors);
        }
        EventEmitter.emit('rebuildDefinition', data.definition);

        this.importModal.close();
        this._showDefintionImportedAlert();
      },
      error: function () {
        content = '<p>An error occurred. Please contact support.</p>';
        this._showImportDefinitionErrors(content);
      },
    });
  },

  _validJsonDefintion: function (definition) {
    try {
      JSON.parse(definition);
    } catch {
      return false;
    }
    return true;
  },

  _cleanImportDefinitionErrors: function () {
    var modalInlineErrors = $('#import-def-errors');

    modalInlineErrors.html('');
    modalInlineErrors.addClass('hidden');
  },

  _showImportDefinitionErrors: function (errorContent) {
    var modalInlineErrors = $('#import-def-errors');

    modalInlineErrors.html(errorContent);
    modalInlineErrors.removeClass('hidden');
  },

  _showDefintionImportedAlert: function () {
    var content = 'Hash Definition successfully imported.';

    if (this.alert) {
      this.alert.close();
    }
    this.alert = new Alert({ message: content, type: 'info' });
    this.alert.prependTo('div#main-content').show();
  },

  _enableHashActionButtons: function () {
    $('.io-form-action-import-hash').removeClass('hidden');
  },

  _toogleAllowAdvanced: function (e) {
    if (e.target.value === 'ip') {
      $(this.dom.ALLOW_ADVANCED).removeClass('hidden');
    } else {
      $(this.dom.ALLOW_ADVANCED).addClass('hidden');
      $(this.dom.ALLOW_ADVANCED).find('input').prop('checked', false);
    }
  },

  _impactCancel: function (e) {
    var form = $(this.dom.IMPACT_FORM);

    e.preventDefault();
    form.append('<input name="edit" type="hidden" value="1" />');
    form.submit();
  },

  _showFeatureWarning: function (e) {
    var element = $(e.target).closest('td'),
      url = window.location.pathname + '/required_feature_enabled.json',
      message =
        'Warning! This feature is disabled for some clients they may could lose data.',
      featureTarget = element.find(':selected').text();

    $.ajax({
      url: url,
      data: { feature: featureTarget },
      success: function (data) {
        element.find('p#feature-warning').remove();
        if (!data.enabled) {
          element.append(
            '<p id="feature-warning" class="pref-diff">' + message + '</p>',
          );
        }
      },
    });
  },

  _warnImpact: function (e) {
    var warnModal,
      target = $(e.target),
      href = target.is('i') ? target.parent().attr('href') : e.target.href,
      url = href + '/impact';

    if (!$(e.target).hasClass('triggered')) {
      e.preventDefault();

      warnModal = new IO.Views.Components.ConfirmationDialog({
        url: url,
        jst_template: 'properties/impacted',
        method: 'GET',
        top: 180,
        transformData: function (data) {
          return {
            impact: data,
            impactedCustomers: Object.keys(data).filter(function (key) {
              return typeof data[key].Customer !== 'undefined';
            }),
            impactedObjects: Object.keys(data).filter(function (key) {
              return (
                typeof data[key].Node !== 'undefined' ||
                typeof data[key].NodeGroup !== 'undefined' ||
                typeof data[key].Server !== 'undefined'
              );
            }),
          };
        },
      });

      warnModal.impact();
      warnModal.answer(function (proceed) {
        warnModal.destroy();
        if (proceed) {
          $(e.target).addClass('triggered').trigger('click');
        }
      });
      return false;
    }

    $(e.target).removeClass('triggered');
  },
});

module.exports = Show;
